import dayjs from 'dayjs';
import { Notification } from '@/context/user-notifications/entities/notification';

import { NOTIFICATION_MAP } from '../constants';
import {
  NOTIFICATION_DATE_FORMAT,
  NOTIFICATION_ICON_MAP,
  NOTIFICATION_TEMPLATES_KEYS,
} from './constants';
import type {
  NotificationDescription,
  NotificationIconIdentifier,
  NotificationTemplate,
} from './types';

const getNotificationIconIdentifier = (type: string): NotificationIconIdentifier => {
  if (type.toLowerCase() === NOTIFICATION_MAP.behavior) {
    return NOTIFICATION_ICON_MAP[type.toLowerCase()] as NotificationIconIdentifier;
  }

  return 'none';
};

const getNotificationTitle = (
  eventName: string,
  type: string,
  translate: (key: string) => string
): NotificationTemplate['title'] => {
  const titlePrefix = translate(`${type}.${eventName}.prefix`);
  const titleTopic = translate(`${eventName ?? NOTIFICATION_TEMPLATES_KEYS.defaults.title}.topic`);

  return {
    titlePrefix,
    titleTopic,
  };
};

const getNotificationDescription = (
  eventName: string,
  topic: string,
  metadata: any,
  translate: (key: string, params?: Record<string, any>) => string
): NotificationTemplate['description'] => {
  if (topic === 'reservation') {
    return {
      plainText: `${translate(`${topic}.${eventName}.description`, {
        date: dayjs(metadata?.date).format('DD/MM/YYYY'),
        time: metadata?.time,
        name: metadata?.reserver?.name,
      })}`,
    };
  }
  return {
    plainText: translate(`${eventName}.description`),
  };
};

const convertTimestampToDate = (timestamp: any): Date => {
  const milliseconds = timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
  return new Date(milliseconds);
};
const getNotificationDate = (timestamp: any, dateFormat: string) => {
  const date = convertTimestampToDate(timestamp);
  return dayjs(date).format(dateFormat) || '';
};

export const getNotificationTemplate = (
  notification: Notification,
  translate: (key: string) => string
): NotificationTemplate | null => {
  const metadata = notification.getMetadata();
  const eventName = notification.getEventName();
  const timestamp = notification.getTimestamp();
  const topic = notification.getTopic().toLowerCase();
  const title = getNotificationTitle(eventName, topic.toLowerCase(), translate);
  const description = getNotificationDescription(eventName, topic, metadata, translate);
  const iconIdentifier = getNotificationIconIdentifier(notification.getType());
  const creationDate = getNotificationDate(timestamp, NOTIFICATION_DATE_FORMAT);
  const user = metadata?.user_name;
  return {
    notification,
    title,
    description,
    iconIdentifier,
    creationDate,
    user,
  };
};
